import script from "./RegionalSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./RegionalSearch.vue?vue&type=script&setup=true&lang=js"

import "./RegionalSearch.vue?vue&type=style&index=0&id=52f592a8&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52f592a8"]])

export default __exports__